import { deviceManager } from "@hid/device/device_manager"

export const handlePair24G = async () => {
    return await deviceManager.deviceDriver.pair24g()
}